import React, { useEffect, useState } from "react";
import { fetchPublicFAQ } from "../../api/siteService";

function FaqItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 py-4 text-left"
      >
        <span
          className={`shrink-0 text-xs text-sky-600 transition-transform duration-200 ${open ? "rotate-90" : ""}`}
        >
          ▶
        </span>
        <span className="font-bold text-slate-800">{item.question}</span>
      </button>
      {open && (
        <div
          className="pb-4 pl-5 pr-2 text-sm leading-7 text-slate-600 prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: item.answer }}
        />
      )}
    </div>
  );
}

function FaqSection({ section }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="mb-1 text-lg font-black text-slate-900">{section.title}</h2>
      <div className="mt-2">
        {section.faqs.map((item) => (
          <FaqItem key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}

export default function Faq() {
  const [sections, setSections] = useState([]);
  const [orphanFaqs, setOrphanFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    fetchPublicFAQ(controller.signal)
      .then((data) => {
        if (Array.isArray(data.sections)) {
          setSections(data.sections);
          setOrphanFaqs(Array.isArray(data.orphan_faqs) ? data.orphan_faqs : []);
        } else if (Array.isArray(data.faqs)) {
          // ancien format sans sections
          setOrphanFaqs(data.faqs);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, []);

  const hasContent = sections.length > 0 || orphanFaqs.length > 0;

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-600">
            QUESTIONS FRÉQUENTES
          </p>
          <h1 className="mt-3 text-4xl font-black text-slate-950">FAQ PixyQuiz</h1>
          <p className="mt-4 max-w-3xl text-base leading-8 text-slate-600">
            Les réponses essentielles sur le jeu, les scores, les propositions
            d'images, les équipes, les battles et la modération.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        {loading ? (
          <div className="py-16 text-center text-sm text-slate-400">Chargement...</div>
        ) : !hasContent ? (
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
            Aucune question pour l'instant.
          </div>
        ) : (
          <div className="space-y-6">
            {sections.map((section) => (
              <FaqSection key={section.id} section={section} />
            ))}
            {orphanFaqs.length > 0 && (
              <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div>
                  {orphanFaqs.map((item) => (
                    <FaqItem key={item.id} item={item} />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </section>
    </div>
  );
}
